import React from "react";

import InstagramLogo from "assets/images/socmed-ig.png";
import FacebookLogo from "assets/images/socmed-fb.png";
import LinkedinLogo from "assets/images/socmed-li.png";

export default function Socmed() {
    return (
        <div className="inline-flex items-center gap-6">
            <div className="font-medium">Check me on</div>
            <div className="cursor-pointer">
                <a
                    href="https://www.instagram.com/hriyntoo/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className="w-10 h-w-10"
                        src={InstagramLogo}
                        alt={InstagramLogo}
                    />
                </a>
            </div>
            <div className="cursor-pointer">
                <a
                    href="https://www.facebook.com/profile.php?id=100009712516295"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className="w-10 h-w-10"
                        src={FacebookLogo}
                        alt={FacebookLogo}
                    />
                </a>
            </div>
            <div className="cursor-pointer">
                <a
                    href="https://www.linkedin.com/in/hari-yanto-92b88b223/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className="w-10 h-w-10"
                        src={LinkedinLogo}
                        alt={LinkedinLogo}
                    />
                </a>
            </div>
        </div>
    );
}
